import { render, staticRenderFns } from "./policyDetail.vue?vue&type=template&id=38b6fb07&scoped=true&"
import script from "./policyDetail.vue?vue&type=script&lang=js&"
export * from "./policyDetail.vue?vue&type=script&lang=js&"
import style0 from "./policyDetail.vue?vue&type=style&index=0&id=38b6fb07&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b6fb07",
  null
  
)

export default component.exports